import { useEffect, useState } from 'react';
import type { Phrase, Folder } from './types';
import { loadMarkdownPhrases } from './markdownSource';
import { loadClientLibrary } from './clientLibrary';

export type MarkdownSource = {
  phrases: Phrase[];
  folders: Folder[];
  searchIndexUrl?: string;
  version?: string;
};

export function useMarkdownSource(): {
  source?: MarkdownSource;
  loading: boolean;
  error?: Error;
} {
  const [source, setSource] = useState<MarkdownSource>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    let cancelled = false;
    // The generated corpus is one compressed request and is cached for offline
    // launches. Retain the bundled Markdown loader as a backwards-compatible
    // fallback for local/test builds whose generated artifacts are missing.
    loadClientLibrary()
      .catch(() => loadMarkdownPhrases())
      .then((s) => {
        if (!cancelled) {
          setSource(s);
          setLoading(false);
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e instanceof Error ? e : new Error(String(e)));
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { source, loading, error };
}
